import React from "react";
import { useSelector } from "react-redux";
import { ArrowUpRight, CheckCircle2, ThumbsUpIcon } from "lucide-react";
import { WhoWeHelpText } from "i18n/about";
import {
  Building2,
  BriefcaseBusiness,
  Users,
  Rocket,
  Landmark,
  Ship,
  Building,
} from "lucide-react";
import { motion } from "framer-motion";
import { slideLeft } from "../../animations/variants";

const WhoWeHelp = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = WhoWeHelpText[lang];
  const icons = [
    Building2,
    BriefcaseBusiness,
    Users,
    Rocket,
    Landmark,
    Ship,
    Building,
  ];

  return (
    <section className="py-20 ">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="font-[Crimson] text-4xl md:text-5xl text-reddark">
            {t.title}
          </h2>

          <div className="w-24 h-[2px] bg-reddark mx-auto mt-6" />
        </div>

        {/* Intro */}
        <div className="text-left mx-auto space-y-6 text-lg leading-8 text-gray-700 ">
          {t.intro.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        {/* Clients */}
        <div className="mt-6">
          <p className="text-left mx-auto space-y-6 text-lg leading-8 text-gray-700 my-6">
            {t.highlight}
          </p>

          {/* <div className="max-w-7xl mx-auto px-0 mb-20">
            <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {t.clients.map((client, index) => (
                <a
                  key={index}
                  href={client.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
    group
    relative
    overflow-hidden
    rounded-2xl
    border border-[#E8DED5]
    bg-white
    transition-all duration-300
    hover:-translate-y-1
    hover:shadow-lg
  "
                >
                  <div
                    className="
      absolute top-0 left-0
      h-1 w-full
      scale-x-0
      origin-left
      transition-transform duration-500
      group-hover:scale-x-100
    "
                    style={{ background: client.color }}
                  />

                  <div className="p-5">
                    <div className="flex flex-col items-start gap-4 mb-4">
                      <div
                        className="
          w-14 h-14
          rounded-2xl
          flex items-center justify-center
          shrink-0
          font-bold text-xl
        "
                        style={{
                          background: `${client.color}15`,
                          color: client.color,
                        }}
                      >
                        {client.title.charAt(0)}
                      </div>

                      <div className="min-w-0 flex-1">
                        <h3
                          className="font-[Crimson] text-xl font-semibold"
                          style={{ color: client.color }}
                        >
                          {client.title}
                        </h3>
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div> */}
          <div className="space-y-6 ml-0 lg:ml-6">
            {t.clients.map((item, index) => (
              <div key={index} className="flex items-start gap-5">
                {/* Icon */}
                <div className="mt-1 text-reddark shrink-0">
                  <ThumbsUpIcon size={20} strokeWidth={1.8} />
                </div>

                {/* Text */}
                <div className="text-lg leading-8 text-gray-800">
                  <span className="font-semibold text-[#111]">
                    {item.title}
                  </span>{" "}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
